module.exports = __webpack_public_path__ + "ba34e17693867c1576fb854203885d15.pdf";